export const hasMacOSKbd = () => {
  return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
};
